import React, { useState, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { CircularProgress } from '@material-ui/core';
import Frame_big from "../../assets/image/Frame_big.svg";
import DialogComponent from "../HelperComponents/DialogComponent/DialogComponent";
import CartDialog from "./CartDialog";
import DefaultButton from "../HelperComponents/DefaultButton/DefaultButton";
import { sessionEnd, cartUpdate } from '../../actions/clientAuthActions';

const MakeOrder = ({ cart, history, openCart, toggleDialog }) => {
    const dispatch = useDispatch();

    const [isConfirmationOpen, setConfirmationOpen] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [isSuccessDialogOpen, setSuccessDialogOpen] = useState(false);
    const [orderNumber, setOrderNumber] = useState('');

    const discount_size = 0;
    const needDelivery = false;
    const deliveryAddress = "";
    const selectedDate = "";

    // --- РОЗРАХУНОК СУМИ ---
    const countTotal = useMemo(() => {
        return cart.reduce((acc, el) => {
            const retail = Number(el.item.retail_price || 0);
            const wholesale = Number(el.item.wholesale_price || 0);

            let finalPrice = retail;

            // Перевірка всіх можливих варіантів назви для опту
            if (
                el.priceType === 'wholesale_price' ||
                el.priceType === 'wholesale' ||
                el.priceType === 'opt' ||
                el.priceType === 'Оптовая' ||
                el.priceType === 2
            ) {
                finalPrice = wholesale;
            }

            return acc + (finalPrice * el.amount);
        }, 0);
    }, [cart]);
    // -----------------------

    const handleOpenConfirmation = () => {
        toggleDialog();
        setConfirmationOpen(true);
    };

    const handleCloseConfirmation = () => {
        setConfirmationOpen(false);
        setError(null);
    };

    const handlePostOrderActions = () => {
        localStorage.removeItem("cart");
        dispatch(cartUpdate());
        setSuccessDialogOpen(false);
        history.push('/main/shop');
    };

    const handleEndConsultation = async () => {
        setLoading(true);
        setError(null);

        const orderItems = cart
            .filter(item => item.stock !== 0)
            .map(el => {
                const item = {
                    id: el.item.id,
                    price_type: el.priceType,
                    quantity: el.amount > el.stock ? el.stock : el.amount
                };
                if (el.discount !== null && el.discount !== 0) {
                    item.discount = el.discount;
                }
                return item;
            });

        const preOrderItems = cart
            .filter(item => item.amount > item.stock)
            .map(el => ({
                id: el.item.id,
                price_type: el.priceType,
                quantity: el.amount - el.stock
            }));

        try {
            const res = await dispatch(sessionEnd(
                localStorage.getItem("client_phone"),
                localStorage.getItem("storage_id"),
                discount_size,
                orderItems,
                preOrderItems,
                needDelivery ? deliveryAddress : "",
                needDelivery ? selectedDate : null
            ));

            if (res.payload && res.payload.status && res.payload.status === 200) {
                setOrderNumber(res.payload.data.number_order);
                setSuccessDialogOpen(true);
                handleCloseConfirmation();
            } else {
                const errorMessage = (res.error && res.error.message) || "Произошла ошибка при оформлении заказа.";
                setError(errorMessage);
            }
        } catch (err) {
            // ВИПРАВЛЕНО: замість optional chaining (err?.response...) використовуємо &&
            const detail = err && err.response && err.response.data && err.response.data.detail;
            setError(detail || "Не удалось связаться с сервером.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <DialogComponent
                open={openCart}
                className="custom_dialog"
                onClose={toggleDialog}
            >
                <div className="dialog_cart">
                    <CartDialog />
                    <div className="total_all">Итого: {countTotal} грн.</div>
                    <DefaultButton
                        onClick={handleOpenConfirmation}
                        variant="contained"
                    >
                        Оформить заказ
                    </DefaultButton>
                </div>
            </DialogComponent>

            <DialogComponent open={isConfirmationOpen} onClose={handleCloseConfirmation}>
                <div className="dialog_client are_you_sure">
                    <div>Завершить консультацию</div>
                    <p>Вы не забыли предложить акцию, услуги, озвучить наши преимущества клиенту?</p>
                    {error && <p style={{ color: 'red', marginTop: '10px' }}>{error}</p>}
                    <div className="button_container">
                        <DefaultButton variant="contained" onClick={handleEndConsultation} disabled={isLoading}>
                            {isLoading ? <CircularProgress size={24} color="inherit" /> : 'OK'}
                        </DefaultButton>
                        <div className="back_btn">
                            <DefaultButton variant="contained_grey" onClick={handleCloseConfirmation} disabled={isLoading}>
                                Отменить
                            </DefaultButton>
                        </div>
                    </div>
                </div>
            </DialogComponent>

            <DialogComponent open={isSuccessDialogOpen} onClose={handlePostOrderActions}>
                <div className="dialog_client">
                    <img src={Frame_big} alt="Frame_big" />
                    <div>Сессия успешно <br /> завершена</div>
                    {orderNumber && <div>Номер заказа: {orderNumber}</div>}
                </div>
            </DialogComponent>
        </>
    );
};

export default MakeOrder;